// extracted by mini-css-extract-plugin
export default {"reactions":"VOokcdRu","label":"se1i9r3Z","input":"_ARReMI5","content":"uWDvhCQZ","count":"TTGvzNOZ"};